import { pipe } from "fp";

import React from "react";

import * as Data from "~/Data";
import * as Layout from "~/Layout";
import * as Log from "~/Log";
import * as NotificationBadge from "~/NotificationBadge";
import * as Typography from "~/Typography";

import * as Table from "./Table";

export const href = () => "issues" as const;

export const Component = (route: Log.Route) => (
  <Layout.Section.Component>
    <Layout.Block.Component all>
      <Typography.H2.Component id={href()}>
        Issues
        <Count.Component {...route} />
      </Typography.H2.Component>
    </Layout.Block.Component>
    <Table.Component {...route} />
  </Layout.Section.Component>
);

export namespace Count {
  type Count = {
    readonly danger: number;
    readonly warning: number;
  };

  export const useFromActiveLog = (route: Log.Route): Count => ({
    danger: pipe(
      Log.Violation.useCountFromActiveLog(route),
      Data.Remote.getOrElse(() => 0)
    ),

    warning: Log.Signature.useFromActiveLog(route, {
      missing: () => 1,
      found: () => 0,
    }),
  });

  export const Component = (route: Log.Route) => (
    <Layout.Inline.Component left>
      {pipe(useFromActiveLog(route), ({ warning, danger }) => (
        <NotificationBadge.Component warning={warning > 0} danger={danger > 0}>
          {warning + danger}
        </NotificationBadge.Component>
      ))}
    </Layout.Inline.Component>
  );
}
